/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICittaAccountSubscriptionViewProps } from './citta-account-subscription';

const CittaAccountSubscriptionView: React.FC<ICittaAccountSubscriptionViewProps> = props => {
    const {
        AccountSubscriptionWrapper,
        AccountSubscriptionAttribute,
        AccountSubscriptionProcessing,
        AccountSubscriptionUnSubscribe,
        subscribeResponse,
        subUnsubButtton,
        isProcessing,
        hasAccountDetails,
        processingMessage,
        subscribeAlert,
        subscribeNote } = props;
    return (
        <Module {...AccountSubscriptionWrapper}>
            {subscribeResponse}
            {hasAccountDetails &&
                <Node {...AccountSubscriptionAttribute}>
                    {isProcessing ?
                        <Node {...AccountSubscriptionProcessing}>
                            {processingMessage}
                        </Node> :
                        <Node {...AccountSubscriptionUnSubscribe}>
                            {subUnsubButtton}
                            {subscribeAlert}
                            {subscribeNote}
                        </Node>}
                </Node>
            }
        </Module>
    );
};

export default CittaAccountSubscriptionView;
